<template>
  <v-container
    id="data-tables"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
      >
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="headers.filter(a=>a.show || a.active)"
              :items="items"
              multi-sort
              :footer-props="datatable_footer"
              :server-items-length="total"
              :options.sync="table_options"
              :loading="loading"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:top>
                <v-card flat>
                  <v-card-text>
                    <v-row dense>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-text-field
                          v-model="form.search"
                          clearable
                          outlined
                          label="Поиск"
                          prepend-inner-icon="mdi-magnify"
                          dense
                          @keyup.enter="load"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-btn
                          color="primary"
                          outlined
                          @click="onFilterDialog"
                        >
                          <v-icon class="ml-3">
                            mdi-filter-variant
                          </v-icon>
                          <span class="mx-3">ФИЛЬТРЫ</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <timezone-picker
                          v-model="timeZone"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        class="text-right d-none d-md-block"
                        md="4"
                      >
                        <v-btn
                          v-if="$store.state.access[20][5] && false"
                          color="primary"

                          @click="$router.push('/admin/payment/create')"
                        >
                          <v-icon class="ml-3">
                            mdi-plus
                          </v-icon>
                          <span class="mx-3">Добавить</span>
                        </v-btn>
                        <v-btn
                          v-if="$store.state.access[20][5]"
                          color="secondary"
                          outlined
                          class="ml-5"
                          @click="report"
                        >
                          <v-icon class="ml-3">
                            mdi-download
                          </v-icon>
                          <span class="mx-3">Выгрузить</span>
                        </v-btn>
                        <v-icon
                          medium
                          class="icon-table"
                          @click="show_header_dialog"
                        >
                          mdi-table-cog
                        </v-icon>
                      </v-col>
                      <v-col
                        cols="12"
                        class="d-md-none"
                      >
                        <v-btn
                          v-if="$store.state.access[20][5] && false"
                          color="primary"
                          @click="$router.push('/admin/payment/create')"
                        >
                          <v-icon class="ml-3">
                            mdi-plus
                          </v-icon>
                          <span class="mx-3">Добавить</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        class="d-md-none"
                      >
                        <v-btn
                          v-if="$store.state.access[20][5]"
                          color="secondary"
                          outlined
                          @click="report"
                        >
                          <v-icon class="ml-3">
                            mdi-download
                          </v-icon>
                          <span class="mx-3">Выгрузить</span>
                        </v-btn>
                      </v-col>
                      <!-- Icon -->
                      <v-col
                        cols="12"
                        class="d-md-none"
                      >
                        <v-icon
                          medium
                          class="icon-table"
                          @click="show_header_dialog"
                        >
                          mdi-table-cog
                        </v-icon>
                      </v-col>
                      <v-col
                        cols="12"
                        class="mt-n5"
                      >
                        <div v-if="filter.set">
                          <div
                            v-for="(tab, index) in filter_fields"
                            :key="'tab_f' + index"
                          >
                            <v-chip
                              v-for="(filter, index2) in tab.data.filter(a=>a.value ||a.value ===0 || a.from || a.to || a.max || a.min)"
                              :key="'data_f' + index2"
                              color="grey lighten-2"
                              class="ma-1"
                              close
                              @click:close="clear_filter_value(filter)"
                            >
                              <span v-if="filter.type == 'date'">{{ filter.name }}: {{ format(filter.from) }}/{{ format(filter.to) }}</span>
                              <span v-else-if="filter.type == 'number'">{{ filter.name }}: {{ (filter.min) }}/{{ (filter.max) }}</span>
                              <span v-else-if="filter.type == 'select' || filter.type == 'autocomplete'">{{ filter.name }}: {{ filter.select.filter(a=>a.value == filter.value)[0].text }}</span>
                              <span v-else>{{ filter.name }}: {{ filter.value }}</span>
                            </v-chip>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
              <template v-slot:item.state="{item}">
                <v-chip :color="get_state_color(item.state)">
                  {{ dict.state[item.state] }}
                </v-chip>
              </template>
              <template v-slot:item.client="{ item }">
                <span v-if="item && item.client">
                  {{ dict.client[item.client] }}
                </span>
              </template>
              <template v-slot:item.payments[0].type="{item}">
                <span>{{ showItem(item.payments, dict.type[item.payments[0].type]) }}</span>
              </template>
              <template v-slot:item.action="{ item }">
                <v-menu
                  :close-on-content-click="false"
                  :nudge-width="100"
                  :nudge-bottom="12"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs, value }">
                    <v-btn
                      v-bind="attrs"
                      color="primary"
                      text
                      v-on="on"
                      @click="sheetitem = item"
                    >
                      <v-icon
                        large
                        class="beg_triangle"
                      >
                        mdi-menu-open
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-list>
                      <v-list-item @click="$router.push('/admin/payment/view?id=' + sheetitem.id)">
                        <v-list-item-content>
                          Открыть
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="$router.push('/admin/payment/archive/view?id=' + sheetitem.id)">
                        <v-list-item-content>
                          Открыть (архивный)
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="$router.push('/admin/order/list?id=' + sheetitem.order)">
                        <v-list-item-content>
                          Перейти к заказу
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="$router.push('/cheque?id=' + sheetitem.id)">
                        <v-list-item-content>
                          Показать чек на отдельной странице
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="decline_payment(sheetitem.id, false)">
                        <v-list-item-content>
                          Отозвать
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="decline_payment(sheetitem.id, true)">
                        <v-list-item-content>
                          Отвергнуть
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="resend(sheetitem.id)">
                        <v-list-item-content>
                          Переотправить (текущий ККТ)
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="resend(sheetitem.id, true)">
                        <v-list-item-content>
                          Переотправить (ККТ точки)
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="resendArchive(sheetitem.id)">
                        <v-list-item-content>
                          Переотправить (архивный текущий ККТ)
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="onResendPs(sheetitem.id)">
                        <v-list-item-content>
                          Переотправить (текущий ПС)
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="onFiscalCompletedDialog(sheetitem.id)">
                        <v-list-item-content>
                          Повторная фискализация
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="onFiscalCompletedArchiveDialog(sheetitem.id)">
                        <v-list-item-content>
                          Повторная фискализация (архивный)
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </template>
              <template v-slot:item.name="{item}">
                <span v-if="item">
                  {{ item.surname }} {{ item.name }} {{ item.patronymic }}
                </span>
              </template>
              <template v-slot:item.phones="{item}">
                <div v-if="item.phones && item.phones.length > 0">
                  <span
                    v-for="(phone, index) in item.phones"
                    :key="index"
                  >
                    {{ phone.number }}<br>
                  </span>
                </div>
              </template>
              <template v-slot:item.createdTZ="{ item }">
                <span v-if="item && item.createdTZ">
                  {{ format_date(item.createdTZ) }}
                </span>
              </template>
              <template v-slot:item.updatedTZ="{ item }">
                <span v-if="item && item.updatedTZ">
                  {{ format_date(item.updatedTZ) }}
                </span>
              </template>
              <template v-slot:item.creator="{ item }">
                <span v-if="item && item.creator">
                  {{ item.creator.surname }} {{ item.creator.name }} {{ item.creator.patronymic }}
                </span>
              </template>
              <template v-slot:item.data="{ item }">
                <span v-if="item && item.fiscal_data">
                  {{ item.fiscal_data.cheque.cheque_number }}/{{ item.fiscal_data.cheque.fd_number }}/{{ item.fiscal_data.cheque.fp }}
                </span>
              </template>
              <template v-slot:item.order_item.sum.comission="{item}">
                <span v-if="item.order_item && item.order_item.sum">
                  {{ Number(item.order_item.sum.comission).money() }}
                </span>
              </template>
              <template v-slot:item.order_item.sum.recipient="{item}">
                <span v-if="item.order_item && item.order_item.sum">
                  {{ Number(item.order_item.sum.recipient).money() }}
                </span>
              </template>
              <template v-slot:item.sum="{item}">
                {{ Number(item.sum).money() }}
              </template>
              <template v-slot:item.items="{item}">
                {{ item.items.reduce((acc,item)=>
                                       acc + `Наименование - ${item.name},  кол-во - ${item.count}, цена - ${item.amount}, ед. изм. - ${item.unit};\n`,
                                     '') }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <v-bottom-sheet v-model="sheet">
          <v-list>
            <v-list-group v-model="sheetmenu">
              <v-list-tile slot="activator">
                <v-list-tile-action>
                  <v-icon>mdi-build</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Действия</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-item @click="decline_payment(sheetitem.id, false)">
                <v-list-item-content>
                  Отозвать
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="resend(sheetitem.id)">
                <v-list-item-content>
                  Переотправить (текущий ККТ)
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="resend(sheetitem.id, true)">
                <v-list-item-content>
                  Переотправить (ККТ точки)
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="resendArchive(sheetitem.id)">
                <v-list-item-content>
                  Переотправить (архивный текущий ККТ)
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="onResendPs(sheetitem.id)">
                <v-list-item-content>
                  Переотправить (текущий ПС)
                </v-list-item-content>
              </v-list-item>
              <!--<v-list-item @click="$router.push('/admin/payment/view?id=' + sheetitem.id)">
                <v-list-item-content>
                  Открыть
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="$router.push('/admin/payment/change?id=' + sheetitem.id)" v-if="$store.state.access[20][3] || $store.state.access[20][4] && sheetitem.creator && sheetitem.creator.id == $store.state.user.id">
                <v-list-item-content>
                  Изменить
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="DeleteItem(sheetitem)" v-if="$store.state.access[20][3] || $store.state.access[20][4] && sheetitem.creator && sheetitem.creator.id == $store.state.user.id">
                <v-list-item-content>
                  Удалить
                </v-list-item-content>
              </v-list-item>-->
            </v-list-group>
          </v-list>
        </v-bottom-sheet>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="filter_dialog"
        persistent
        max-width="900px"
      >
        <base-material-card
          color="primary"
          icon="mdi-filter-outline"
          inline
          class="filter_popup"
        >
          <v-card-title>
            <span class="text-h5">Фильтры</span>
          </v-card-title>
          <v-card-text>
            <v-tabs
              v-model="tab_index"
              v-resize="onResizeWindow"
              :vertical="verticalTabs"
            >
              <v-tab
                v-for="(tab, index) in filter_fields"
                :key="index"
              >
                <div class="filter_row">
                  {{ tab.name }}
                  <v-btn
                    icon
                    @click="setFavouriteTab(tab.index)"
                  >
                    <v-icon
                      left
                      :class="[{'active': $store.state.user.tab_item == tab.index}]"
                    >
                      mdi-star
                    </v-icon>
                  </v-btn>
                </div>
              </v-tab>

              <v-tab-item
                v-for="(tab, index) in filter_fields"
                :key="index"
              >
                <v-card flat>
                  <v-card-text>
                    <div
                      v-for="(field, index2) in tab.data"
                      :key="'i_'+index2"
                    >
                      <v-select
                        v-if="field.type=='select'"
                        v-model="field.value"
                        clearable
                        :label="field.name"
                        :items="field.select"
                        @change="filter.changed = true"
                      />
                      <div
                        v-else-if="field.type=='date'"
                        clearable
                        :label="field.name"
                        :items="field.select"
                      >
                        <v-row>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-select
                              v-model="field.date_select"
                              clearable
                              :label="field.name"
                              :items="[{value:'yesterday', text:'Вчера'},{value:'today', text:'Сегодня'},{value:'tomorrow', text:'Завтра'},{value:'date', text:'Конкретная дата'},{value:'period', text:'Период дат'}]"
                              @change="changeFilterDateType($event, index , field)"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-model="field.from"
                              :label="field.date_select == 'period' ? 'От' : 'Конкретная дата'"
                              :disabled="field.date_select !== 'period' && field.date_select !== 'date'"
                              type="date"
                              :max="max_date"
                              @input="filter.changed = true"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-if="field.date_select == 'period'"
                              v-model="field.to"
                              label="До"
                              type="date"
                              :max="max_date"
                              @input="filter.changed = true"
                            />
                          </v-col>
                        </v-row>
                      </div>
                      <div v-else-if="field.type=='number'">
                        <v-row>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              :label="field.name"
                              readonly
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-model="field.min"
                              label="От"
                              type="number"
                              @input="filter.changed = true"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-model="field.max"
                              label="До"
                              type="number"
                              @input="filter.changed = true"
                            />
                          </v-col>
                        </v-row>
                      </div>
                      <v-autocomplete
                        v-else-if="field.type==='autocomplete'"
                        v-model="field.value"
                        clearable
                        :label="field.name"
                        :items="field.select"
                        @change="filter.changed = true"
                      />
                      <v-text-field
                        v-else
                        v-model="field.value"
                        :label="field.name"
                        :type="field.type"
                        @input="filter.changed = true"
                      />
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              width="80"
              color="primary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-primary"
              @click="filter_dialog = false, set_filter()"
            >
              <span class="mx-10">Применить</span>
            </v-btn>
            <v-btn
              width="80"
              color="secondary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-secondary"
              @click="filter_dialog = false"
            >
              <span class="mx-10">Закрыть</span>
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-dialog>
      <v-dialog
        v-model="dialog.headers.show"
        persistent
        max-width="900px"
      >
        <base-material-card
          color="primary"
          icon="mdi-table-cog"
          inline
          class="filter_popup"
        >
          <v-card-title>
            <span class="text-h5">Настройка столбцов</span>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :items-per-page="5"
              dense
              :items="headers.filter(a=>!a.show)"
              :headers="[{value: 'text', text: 'Название столбца'}, {value: 'active_temp', text: 'Отображение'}]"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:item.active_temp="{item}">
                <v-checkbox v-model="item.active_temp" />
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              width="80"
              color="primary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-primary"
              @click="dialog.headers.show = false, set_headers()"
            >
              <span class="mx-10">Сохранить</span>
            </v-btn>
            <v-btn
              width="80"
              color="secondary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-secondary"
              @click="dialog.headers.show = false"
            >
              <span class="mx-10">Закрыть</span>
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-dialog>
      <dialog-yes-no
        v-if="dialogYesNoVisible"
        title="Повторная фискализация"
        text="Вы уверены провести фискалицию?"
        @no="dialogYesNoVisible=false"
        @yes="dialogYesNo.actionYes"
      />
    </v-row>
  </v-container>
</template>
<style lang="scss">
.icon-filter {
  color: grey;
  &.active {
    color:orange;
  }
  &:not(.active):hover {
    color: #315bbf;
  }
}
.icon-magnify {
  color: rgb(121, 114, 118);
  &:hover {
    color: #315bbf;
  }
}
.icon-table {
  height: 30px;
  width: 30px;
  margin-top: 3px;
  margin-left: 8px;
  color: grey;
  &:hover {
    color: #315bbf;
  }
}
.btns-edit-group {
  height: 36px!important;
  .beg_pencil {
    background-color: rgb(0, 143, 203)!important;
    bpayment-color: rgb(24, 123, 154)!important;
    color: white;
    bpayment-bottom-right-radius: 0;
    bpayment-top-right-radius: 0;
    min-width: 50px!important;
    width: 50px!important;
    height: 36px!important;
  }
  .beg_select {
    background-color: rgb(0, 143, 203)!important;
    bpayment-color: rgb(24, 123, 154)!important;
    color: white;
    bpayment-bottom-left-radius: 0;
    bpayment-top-left-radius: 0;
    min-width: 30px!important;
    width: 30px!important;
    height: 36px!important;

    .beg_triangle {
      transform: scale(0.36,0.22) rotate(180deg);
    }
    &.active {
      .beg_triangle {
        transform: scale(0.36,0.22) rotate(0deg);
      }
    }
  }
  .v-btn__content,
  i {
    height: 36px!important;
  }
}
/**popup */
.filter_popup .v-tabs--vertical > .v-tabs-bar .v-tab {
  display: flex;
  flex-direction: column;
  height: 80px;
  width: 140px;
  font-size: 0.6rem !important;
  line-height: 0.8rem;
  white-space: pre-wrap;
  .filter_row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .v-btn {
      height: 30px;
      width: 30px;
      margin-right: -15px;
      &:hover {
        .v-icon {
          color: rgba(0, 0, 0, 0.1);
        }
      }
      .v-icon {
        margin: 0px;
        color: rgba(0, 0, 0, 0.01);
        &.active {
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }
  }
}
@media (min-width: 960px) {
  .filter_popup .v-tabs--vertical > .v-tabs-bar .v-tab {
    flex-direction: row;
    height: 54px;
    width: 180px;
    font-size: 0.70rem !important;
    line-height: 0.8rem;
    white-space: pre-wrap;
    .filter_row {
      .v-btn {
        margin-left: 10px;
      }
    }
  }
}
/** _popup */

.search-row {
  display: flex;
  flex-direction: row;
}
.search-title {
  padding-top: 24px;
  padding-right: 10px;
  margin-top: 4px;
  font-size: 1.6rem;
  color: #ec7e2f;
}
.table_item {
  font-size: 0.929rem;
  padding-bottom: 12px;
}
.table_item:first-of-type {
  padding-top: 12px;
}

.table_item__title {
  font-size: 0.929rem;
}
.table_item__subtitle {
  font-size: 0.875rem;
  line-height: 1.2;
  color: #999;
}
</style>
<script>
  import suggest from '../../libs/suggestions.min.17.12.0.dev.js'
  import moment from 'moment'
  import $ from 'jquery'
import { truncate } from 'fs'
import { parse } from 'path'
  import TimezonePicker from "@/views/loyalty/shared/components/timezone-picker/TimezonePicker.vue"
  import { utcToZonedTime } from "date-fns-tz"
  import { toDate } from "date-fns"
  import { JustpayPaymentService } from "@/views/loyalty/shared/services/justpay-payment-service"
  import DialogTextfield from "@/views/loyalty/shared/components/dialog-textfield/DialogTextfield.vue"
  import DialogEditTextfield from "@/views/loyalty/shared/components/dialog-textfield/DialogEditTextfield.vue"
  import DialogYesNo from "@/views/loyalty/shared/components/dialog-yesno/DialogYesNo.vue"
  export default {
    name: 'DashboardDataTables',
    components: { DialogYesNo, DialogEditTextfield, DialogTextfield, TimezonePicker },
    data: () => ({
      table_options: {

      },
      total: 0,
      loading: false,
      tab_index: 0,
      dialog: {
        headers: {
          show: false
        }
      },
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageAllText: 'Все',
        itemsPerPageOptions: [5, 10, 15, 30, 50],
      },
      sheet: false,
      sheetmenu: true,
      sheetitem: {},
      headers: [
        {
          text: 'Действия',
          value: 'action',
          show: true
        },
        {
          text: 'Дата/время платежа',
          value: 'createdTZ',
          active: true,
          active_temp: false
        },
        {
          text: 'Номер платежа',
          value: 'number',
          active: true,
          active_temp: false
        },
        {
          text: 'Сумма платежа',
          value: 'sum',
          active: true,
          active_temp: false
        },
        {
          text: 'Детали платежа',
          value: 'items',
          active: true,
          active_temp: false
        },
        {
          text: 'Сумма получателя',
          value: 'order_item.sum.recipient',
          active: false,
          active_temp: false
        },
        {
          text: 'Сумма комиссии',
          value: 'order_item.sum.comission',
          active: false,
          active_temp: false
        },
        {
          text: 'Плательщик',
          value: 'items[0].attributes.payer_fio',
          active: true,
          active_temp: false
        },
        {
          text: 'Серия документа',
          value: 'items[0].attributes.payer_doc_series',
          actie: true,
          active_temp: false
        },
        {
          text: 'Номер документа',
          value: 'items[0].attributes.payer_doc_number',
          actie: true,
          active_temp: false
        },
        {
          text: 'Получатель',
          value: 'items[0].attributes.recipient_name_short',
          active: true,
          active_temp: false
        },
        {
          text: 'Статус',
          value: 'state',
          active: true,
          active_temp: false
        },
        {
          text: 'Дата/время статуса',
          value: 'updatedTZ',
          active: false,
          active_temp: false
        },
        {
          text: 'Пользователь',
          value: 'creator',
          active: false,
          active_temp: false
        },
        {
          text: 'Назначение платежа',
          value: 'items[0].attributes.dest',
          active: false,
          active_temp: false
        },
        {
          text: 'Услуга',
          value: 'items[0].name',
          active: false,
          active_temp: false
        },
        {
          text: 'ИНН получателя',
          value: 'items[0].attributes.recipient_inn',
          active: false,
          active_temp: false
        },
        {
          text: 'Наименование получателя',
          value: 'items[0].attributes.recipient_name_full',
          active: false,
          active_temp: false
        },
        {
          text: 'Наименование получателя по реквизитам',
          value: 'items[0].attributes.recipient_name',
          active: false,
          active_temp: false
        },
        {
          text: 'Номер точки обслуживания',
          value: 'point.number',
          active: false,
          active_temp: false
        },
        {
          text: 'Точка обслуживания',
          value: 'point.name',
          active: false,
          active_temp: false
        },
        {
          text: 'Место обслуживания',
          value: 'point.place_item.address',
          active: false,
          active_temp: false
        },
        {
          text: 'Фискальные данные',
          value: 'data',
          active: false,
          active_temp: false
        },
        {
          text: 'Идентификатор в ПС',
          value: 'moneta.id',
          active: false,
          active_temp: false
        },
        {
          text: 'Тип оплаты',
          value: 'payments[0].type',
          active: false,
          active_temp: false
        },
        {
          text: 'RRN',
          value: 'payments[0].data.rrn',
          active: false,
          active_temp: false
        },
        {
          text: 'Код авторизации',
          value: 'payments[0].data.auth_code',
          active: false,
          active_temp: false
        },
        {
          text: 'PAN',
          value: 'payments[0].data.pan',
          active: false,
          active_temp: false
        },
        {
          text: 'Платежная система',
          value: 'payments[0].data.card_name',
          active: false,
          active_temp: false
        },
        {
          text: 'TID',
          value: 'payments[0].data.tid',
          active: false,
          active_temp: false
        },
        {
          text: 'Мерчант',
          value: 'payments[0].data.merchant',
          active: false,
          active_temp: false
        },
        {
          text: 'Последний статус',
          value: 'state_comment',
          active: false,
          active_temp: false
        },
        {
          text: 'Номер ячейки',
          value: 'items[0].vending_number',
          active: false,
          active_temp: false
        },
        {
          text: 'Артикул',
          value: 'items[0].article',
          active: false,
          active_temp: false
        },
      ],
      doc_type: {

      },
      items: [],
      form: {},
      search: "",
      select: {
      },
      dict: {
        state: {
          0: 'Новый',
          1: 'Обработка ККТ',
          2: 'Обработан ККТ',
          3: 'Обработка ПС',
          4: 'Обработан ПС',
          5: 'Ошибка ККТ',
          6: 'Ошибка ПС',
          7: 'Отозван',
          8: 'Завершен',
          9: 'Ошибка сети',
          10: 'Отмена банковской операции',
          11: 'Банковская операция отменена'
        },
        type: {
          0: 'Наличные',
          1: 'Банковская карта',
          2: 'СБП'
        },
        client: {}
      },
      filter_dialog: false,
      filter_fields: {
        common: {
          index: 0,
          name: "Основное",
          active: true,
          data: [
            {
          name: 'Дата/время платежа',
          data: 'created',
          type: 'date'
        },
        {
          name: 'Номер платежа',
          data: 'number',
          type: 'text',
        },
        {
          name: 'Номер карты',
          data: 'payments.data.pan',
          type: 'text',
        },
        {
          name: 'Сумма платежа',
          data: 'sum',
          type: 'number'
        },
        {
          name: 'Сумма получателя',
          data: 'order_item.sum.recipient',
          type: 'number'
        },
        {
          name: 'Сумма комиссии',
          data: 'order_item.sum.comission',
          type: 'number'
        },
        {
          name: 'Плательщик',
          data: 'items.attributes.payer_fio',
          type: 'text'
        },
        {
          name: 'Серия документа',
          data: 'items.attributes.payer_doc_series',
          type: 'text'
        },
        {
          name: 'Номер документа',
          data: 'items.attributes.payer_doc_number',
          type: 'text'
        },
        {
          name: 'Получатель',
          data: 'items.attributes.recipient_name_short',
          type: 'text'
        },
        {
          name: 'Статус',
          data: 'state',
          type: 'select',
          select: [
            { value: 0, text: 'Новый' },
          { value: 1, text: 'Обработка ККТ' },
          { value: 2, text: 'Обработан ККТ' },
          { value: 3, text: 'Обработка ПС' },
          { value: 4, text: 'Обработан ПС' },
          { value: 5, text: 'Ошибка ККТ' },
          { value: 6, text: 'Ошибка ПС' },
          { value: 7, text: 'Отозван' },
          { value: 8, text: 'Завершен' },
          { value: 9, text: 'Ошибка сети' },
          { value: 10, text: 'Отмена банковской операции' },
          { value: 11, text: 'Банковская операция отменена' }
          ]
        },
        {
          name: 'Дата/время статуса',
          data: 'updated',
          type: 'date'
        },
        {
          name: 'Назначение платежа',
          data: 'items.attributes.dest',
          type: 'text'
        },
        {
          name: 'Услуга',
          data: 'items.name',
          type: 'text'
        },
        {
          name: 'ИНН получателя',
          data: 'items.attributes.recipient_inn',
          type: 'text'
        },
        {
          name: 'Наименование получателя',
          data: 'items.attributes.recipient_name_full',
          type: 'text'
        },
        {
          name: 'Наименование получателя по реквизитам',
          data: 'items.attributes.recipient_name',
          type: 'text'
        },
        {
          name: 'Номер точки обслуживания',
          data: 'point.number',
          type: 'text'
        },
        {
          name: 'Точка обслуживания',
          data: 'point.name',
          type: 'autocomplete',
          select: []
        },
        {
          name: 'Тип оплаты',
          data: 'payments.type',
           type: 'select',
          select: [
            { value: 0, text: 'Наличные   ' },
            { value: 1, text: 'Банковская карта' },
            { value: 2, text: 'СБП' },
          ]
        },
        {
          name: 'RRN',
          data: 'payments.data.rrn',
          type: 'text'
        },
        {
          name: 'Код авторизации',
          data: 'payments.data.auth_code',
           type: 'text'
        },
        {
          name: 'PAN',
          data: 'payments.data.pan',
           type: 'text'
        },
        {
          name: 'Платежная система',
          data: 'payments.data.card_name',
           type: 'text'
        },
        {
          name: 'TID',
          data: 'payments.data.tid',
           type: 'text'
        },
        {
          name: 'Артикул',
          data: 'items.article',
           type: 'text'
        },
        {
          name: 'Клиент',
          data: 'client',
          type: 'autocomplete',
          select: []
        },
          ]
        }
      },
      filter: {
        set: false
      },
      entity: 'admin.payment',
      timeZone: '',
      justpayPaymentService: null,
      verticalTabs: true,
      dialogTextFieldVisible: false,
      dialogYesNoVisible: false,
      payment: {},
      dialogYesNo: {
        title: '',
        text: '',
        actionYes: null,
      },
    }),
    computed: {
      max_date: function () {
        return moment().format('YYYY-MM-DD')
      },
    },
    watch: {
      table_options: {
        handler () {
          console.log(this.table_options)
          this.$router.push({
            query: {
              page: this.table_options.page,
              limit: this.table_options.itemsPerPage
            }
          })
          this.load()
        },
        deep: true,
      },
      timeZone: {
        handler () {
          this.items = this.getItemsWithTZ(this.items)
        }
      }
    },
    beforeRouteEnter (to, from, next) {
      localStorage.removeItem('admin.client')
      localStorage.removeItem('admin.configuration')
      localStorage.removeItem('admin.device')
      localStorage.removeItem('admin.member')
      localStorage.removeItem('admin.equipment')
      localStorage.removeItem('admin.event')
      localStorage.removeItem('admin.fiscal')
      localStorage.removeItem('admin.item')
      localStorage.removeItem('admin.kkt')
      localStorage.removeItem('admin.operator')
      localStorage.removeItem('admin.place')
      localStorage.removeItem('admin.point')
      localStorage.removeItem('admin.role')
      localStorage.removeItem('admin.user')
      localStorage.removeItem('admin.sbpbank')
      localStorage.removeItem('admin.sbpprofile')
      localStorage.removeItem('admin.nomenclature')
      localStorage.removeItem('admin.category')
      localStorage.removeItem('admin.order')
      // localStorage.removeItem('admin.payment')
      next()
    },
    beforeMount () {
      this.justpayPaymentService = new JustpayPaymentService()
    },
    mounted: async function () {
      if (this.$route.query.id) {
        this.form.id = this.$route.query.id
      } else {
        const filter = localStorage.getItem(this.entity)
        if (filter) {
          this.filter_fields = JSON.parse(filter)
          this.filter.set = true
          this.filter.changed = false
        }
      }
      if (this.$route.query.page) {
        this.table_options.page = Number(this.$route.query.page)
        this.table_options.itemsPerPage = Number(this.$route.query.limit)
      }
      for (const x in this.$store.state.dict.doc_type) {
        if (this.$store.state.dict.doc_type[x].type) {
          this.doc_type[this.$store.state.dict.doc_type[x].type] = Number(x)
          for (const y in this.filter_fields.documents.data) {
            if (this.filter_fields.documents.data[y].key == this.$store.state.dict.doc_type[x].type) {
              this.filter_fields.documents.data[y].extra = { data: 'type', value: Number(x) }
            }
          }
        }
      }
      // const points_for_filter = await justpayPaymentService.getPointsForPaymentFilter()
      // this.filter_fields.common.data.map(item => {
      //   if (item.data === 'point.name') {
      //     item.select = [...points_for_filter]
      //     return item
      //   }
      // })
      this.tab_index = this.$store.state.user.tab_item
      // this.load()
      this.set_default_headers()
    },
    methods: {
      decline_payment: function (id, ingore_refund_card) {
        this.axios.post('/api/payment/decline', {
          id: id,
          ingore_refund_card
        })
            .then(result => {
              this.loading = false
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Успешно')
                this.load()
              } else {
                this.$store.commit('snackbar', result.data.data)
              }
            })
            .catch(error => {
              this.loading = false
              this.$store.commit('snackbar', error)
            })
      },
      resend: function (id, clean) {
        var url = '/api/payment/resend/current/' + id
        if (clean) {
          url = '/api/payment/resend/clean/' + id
        }
        this.axios.post(url, {})
            .then(result => {
              this.loading = false
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Успешно')
                this.load()
              } else {
                this.$store.commit('snackbar', result.data.data)
              }
            })
            .catch(error => {
              this.loading = false
              this.$store.commit('snackbar', error)
            })
      },
      resendArchive: function (id, clean) {
        var url = '/api/payment/resend/current/archive/' + id
        // if (clean) {
        //   url = '/api/payment/resend/clean/' + id
        // }
        this.axios.post(url, {})
            .then(result => {
              this.loading = false
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Успешно')
                this.load()
              } else {
                this.$store.commit('snackbar', result.data.data)
              }
            })
            .catch(error => {
              this.loading = false
              this.$store.commit('snackbar', error)
            })
      },
      set_default_headers: function () {
          if (!this.$store.state.user.payment_headers || this.$store.state.user.payment_headers.length == 0) return
          for (const x in this.headers) {
            this.headers[x].active = this.$store.state.user.payment_headers.indexOf(this.headers[x].value) > -1
          }
      },
      clear_filter_value: function (field) {
        field.value = ''
        field.from = ''
        field.to = ''
        field.date_select = ''
        field.min = ''
        field.max = ''
         field.min = ''
        field.max = ''
        this.filter.changed = true
        this.set_filter()
      },
      report: function () {
        const request = JSON.parse(JSON.stringify(this.form))
        if (this.filter.set) {
          request.data = JSON.parse(JSON.stringify(this.filter_fields))
          delete request.data.set
          delete request.data.changed
        }
        request.headers = this.headers.filter(a => a.active == true).map(a => a.value)
        // in PaymentController l.713 , field is "created"
        request.headers = request.headers.map(header => {
          if (header === 'createdTZ') {
            header = 'created'
          }
          if (header === 'updatedTZ') {
            header = 'updated'
          }
          return header
        })
        const form = $('<form>', {
            target: '_blank',
            action: '/api/payment/export?token=' + localStorage.getItem("token"),
            method: 'post',
          })
          form.append(
            $('<input>', {
              type: 'hidden',
              value: JSON.stringify(request),
              name: 'form',
            })
          )
          form.appendTo('body').submit()
      },
      get_state_color: function (state) {
        if (state == 0) return 'green'
        if (state == 1) return 'yellow'
      },
      accept: function (item) {
        item.state = 1
          this.axios.post('/api/payment/save', item)
            .then(result => {
              this.loading = false
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Успешно')
                this.load()
              } else {
                this.$store.commit('snackbar', 'Ошибка при сохранении')
              }
            })
            .catch(error => {
              this.loading = false
              this.$store.commit('snackbar', 'Ошибка при сохранении')
            })
      },
      setFavouriteTab: function (index) {
        this.axios.post('/api/user/favourite_tab', { value: index, type: 'tab_item' })
          .then(result => {
            if (!result.data.error) {
              this.$store.commit('SET_FAVOURITE_TAB', { value: index, type: 'tab_item' })
            }
          })
          .catch(e => {
          })
      },
      DeleteItem: function (item) {
        this.sheet = false
        if (confirm('Вы уверены?')) {
          item.deleted = true
          this.axios.post('/api/payment/save', item)
            .then(result => {
              this.loading = false
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Удаление успешно')
                this.load()
              } else {
                this.$store.commit('snackbar', 'Ошибка при удалении')
              }
            })
            .catch(error => {
              this.loading = false
              this.$store.commit('snackbar', 'Ошибка при удалении')
            })
        }
      },
      show_header_dialog: function () {
        for (const x in this.headers) {
          this.headers[x].active_temp = this.headers[x].active
        }
        this.dialog.headers.show = true
      },
      set_headers: function () {
        for (const x in this.headers) {
          this.headers[x].active = this.headers[x].active_temp
        }
        this.$axios.post('/api/user/headers', {
          entity: 'payment',
          headers: this.headers.filter(a => a.active).map(a => a.value)
        })
        .catch(e => {
          console.log(e)
        })
      },
      fill_dict: function (data, dict) {
        data.select = []
        for (const x in dict) {
          data.select.push({ value: Number(x), text: dict[x].name })
        }
      },
      set_filter: function (flag) {
        if (this.filter.changed) this.filter.set = true
        this.filter.changed = false
        this.load()
        localStorage.setItem(this.entity, JSON.stringify(this.filter_fields))
      },
      clear_filter: function () {
        this.filter.set = false
        for (const x in this.filter_fields) {
          for (const y in this.filter_fields[x].data) {
             this.filter_fields[x].data[y].value = ''
             this.filter_fields[x].data[y].from = ''
             this.filter_fields[x].data[y].to = ''
          }
        }
        localStorage.removeItem(this.entity)
      },
      formatInputDate: function (_date) {
        const date = new Date(_date)
        let dd = date.getDate()
        if (dd < 10) dd = '0' + dd

        let mm = date.getMonth() + 1
        if (mm < 10) mm = '0' + mm

        let yyyy = date.getFullYear()
        if (yyyy < 10) yyyy = '0' + yyyy

        return yyyy + '-' + mm + '-' + dd
      },
      changeFilterDateType (value, tab, field) {
        this.filter.changed = true
        console.log('changeFilterDateType', value, tab, field)
        if (tab && field && value) {
          if (value !== 'period' && value !== 'date') {
            let date = 0
            if (value == 'today') {
              date = new Date()
            } else if (value == 'yesterday') {
              date = new Date().setDate(new Date().getDate() - 1)
            } else if (value == 'tomorrow') {
              date = new Date().setDate(new Date().getDate() + 1)
            }
            const formated_date = this.formatInputDate(date)
            field.from = formated_date
            field.to = formated_date
          }
          if (value == 'date') {
            field.to = ''
          }
        }
      },
      format_date: function (date) {
        return moment(date).format('DD.MM.YYYY HH:mm:ss')
      },
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      getDoc: function (item) {
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/document',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      clear: function () {
        this.form = {
        },
        this.load()
      },
      load: function (clear) {
        const request = JSON.parse(JSON.stringify(this.form))
        if (this.filter.set) {
          request.data = JSON.parse(JSON.stringify(this.filter_fields))
          delete request.data.set
          delete request.data.changed
          delete request.id
        }
        this.loading = true
        const { sortBy, sortDesc, page, itemsPerPage } = this.table_options
        request.page = page
        request.limit = itemsPerPage
        localStorage.setItem(this.entity, JSON.stringify(this.filter_fields))
        if (this.$route.query.order) {
          request.order = this.$route.query.order
        }
        this.axios.post('/api/payment/list', request)
          .then(result => {
             this.loading = false
            this.form.id = null
            if (!result.data.error) {
              this.items = result.data.data
              this.items = this.getItemsWithTZ(this.items)
              this.items = this.fillEmptyPayments(this.items)
              this.dict.client = {}
              // for (const x in result.data.clients) {
              //   this.dict.client[result.data.clients[x].id] = result.data.clients[x].legal.name.short
              // }
              this.total = result.data.count
            } else {
              this.items = []
              this.total = 0
            }
          })
          .catch(e => {
             this.loading = false
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
      // async editPayment (paymentId) {
      //   const response = await this.justpayPaymentService.getPayment({ id: paymentId })
      //   if (!response.error) {
      //     this.payment = response.data[0]
      //     this.dialogTextFieldVisible = true
      //   }
      // },
      fillEmptyPayments (items) {
        items = items.map(item => {
          if (!item.payments || item.payments.length < 1) {
            item.payments = [{ type: 0, reverse_data: '' }]
          }
          return item
        })
        return items
      },
      getItemsWithTZ (items) {
        items = items.map(item => {
          item.createdTZ = utcToZonedTime(item.created, this.timeZone)
          item.updatedTZ = utcToZonedTime(item.updated, this.timeZone)
          return item
        })
        return items
      },
      // async onChangePayment (sum) {
      //   this.dialogTextFieldVisible = false
      //   console.log('onChangePayment sum', sum)
      //   if (this.payment) {
      //     if (!Number.isNaN(+sum)) {
      //       this.payment.sum = +sum
      //       await this.justpayPaymentService.changePayment(this.payment)
      //       this.load()
      //       this.loading = false
      //     }
      //   }
      // },
      onFiscalCompletedDialog (itemId) {
        this.dialogYesNoVisible = true
        this.dialogYesNo.actionYes = this.onResendCompleted.bind(this, itemId)
      },
      onFiscalCompletedArchiveDialog (itemId) {
        this.dialogYesNoVisible = true
        this.dialogYesNo.actionYes = this.onResendCompletedArchive.bind(this, itemId)
      },
      async onFilterDialog () {
        this.filter_dialog = true
        const filters = await this.justpayPaymentService.getForFiltering()
        this.filter_fields.common.data.map(item => {
          if (item.data === 'point.name') {
            item.select = [...filters.points.map(point => { return { value: point.text, text: point.text } })]
            return item
          }
          if (item.data === 'client') {
            item.select = [...filters.clients.map(client => { return { value: client.value, text: client.text } })]
            return item
          }
        })
      },
      onResendCompleted (paymentId) {
        const result = this.justpayPaymentService.resendPaymentForCompleted(paymentId)
        this.dialogYesNoVisible = false
        if (!result.error) {
          this.$store.commit('snackbar', 'Успешно')
          this.load()
        } else {
          this.$store.commit('snackbar', result.data.data)
        }
      },
      onResendCompletedArchive (paymentId) {
        const result = this.justpayPaymentService.resendPaymentForCompletedArchive(paymentId)
        this.dialogYesNoVisible = false
        if (!result.error) {
          this.$store.commit('snackbar', 'Успешно')
          this.load()
        } else {
          this.$store.commit('snackbar', result.data.data)
        }
      },
      onResendPs (paymentId) {
        const result = this.justpayPaymentService.resendPaymentForPs(paymentId)
        if (!result.error) {
          this.$store.commit('snackbar', 'Успешно')
          this.load()
        } else {
          this.$store.commit('snackbar', result.data.data)
        }
      },
      onResizeWindow () {
        this.verticalTabs = window.innerWidth > 600
      },
      showItem (obj, item) {
        if (obj) { return item } else { return 0 }
      },
    },
  }
</script>
